module.exports = __webpack_public_path__ + "img/6BBD6B_C8F3C8_A3E2A3_B4ECB4-256px.505d18f2.png";